import React from 'react';
import LoanProgramTemplate from './LoanProgramTemplate';

export default function ConventionalLoanPage() {
  return (
    <LoanProgramTemplate
      title="Conventional Financing"
      subtitle="Our Loan Programs"
      heroImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1778098866/in-flight_3_n3rham.png"
      contentImage="https://res.cloudinary.com/ddhrdxc7d/image/upload/v1777907276/Conventional_zzaroz.png"
      descriptionBold="Conventional loans"
      description="follow guidelines set by Fannie Mae and Freddie Mac and are among the most widely used mortgage options. They offer strong flexibility and competitive pricing for qualified borrowers."
      whyBuyersConsider="Conventional loans can offer competitive rates and flexible terms for borrowers with solid credit, making them a popular option for long-term affordability and stability."
      eligibilityItems={[
        'Minimum credit score requirements apply',
        'Down payments typically range from 3 to 20 percent depending on the borrower profile',
        'Standard debt-to-income limits apply',
        'Income must be documented and stable',
        'Loan amount must fall within annual FHFA conforming limits',
      ]}
      benefitsItems={[
        'Competitive interest rate options',
        'Private mortgage insurance can be removed once sufficient equity is reached',
        'Works with primary residences, second homes, and investment properties',
        'No upfront mortgage insurance premium required',
      ]}
    />
  );
}
